export default __webpack_public_path__ + "static/media/Fend This Off If You Can.02af0a0a.png";